import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Matrix, settings, utils, MASK_TYPES } from '@pixi/core';
import { DisplayObject } from './DisplayObject.mjs';
var tempMatrix = new Matrix();
function _sortChildren(a, b) {
  if (a.zIndex === b.zIndex) {
    return a._lastSortedIndex - b._lastSortedIndex;
  }
  return a.zIndex - b.zIndex;
}
var Container = /*#__PURE__*/function (_DisplayObject) {
  _inherits(Container, _DisplayObject);
  var _super = _createSuper(Container);
  function Container() {
    var _this;
    _classCallCheck(this, Container);
    _this = _super.call(this);
    _this.children = [];
    _this.sortableChildren = settings.SORTABLE_CHILDREN;
    _this.sortDirty = false;
    return _this;
  }
  _createClass(Container, [{
    key: "onChildrenChange",
    value: function onChildrenChange(_length) {}
  }, {
    key: "addChild",
    value: function addChild() {
      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length; i++) {
          this.addChild(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        }
      } else {
        var child = arguments.length <= 0 ? undefined : arguments[0];
        if (child.parent) {
          child.parent.removeChild(child);
        }
        child.parent = this;
        this.sortDirty = true;
        child.transform._parentID = -1;
        this.children.push(child);
        this._boundsID++;
        this.onChildrenChange(this.children.length - 1);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
      }
      return arguments.length <= 0 ? undefined : arguments[0];
    }
  }, {
    key: "addChildAt",
    value: function addChildAt(child, index) {
      if (index < 0 || index > this.children.length) {
        throw new Error("".concat(child, "addChildAt: The index ").concat(index, " supplied is out of bounds ").concat(this.children.length));
      }
      if (child.parent) {
        child.parent.removeChild(child);
      }
      child.parent = this;
      this.sortDirty = true;
      child.transform._parentID = -1;
      this.children.splice(index, 0, child);
      this._boundsID++;
      this.onChildrenChange(index);
      child.emit("added", this);
      this.emit("childAdded", child, this, index);
      return child;
    }
  }, {
    key: "swapChildren",
    value: function swapChildren(child, child2) {
      if (child === child2) {
        return;
      }
      var index1 = this.getChildIndex(child);
      var index2 = this.getChildIndex(child2);
      this.children[index1] = child2;
      this.children[index2] = child;
      this.onChildrenChange(index1 < index2 ? index1 : index2);
    }
  }, {
    key: "getChildIndex",
    value: function getChildIndex(child) {
      var index = this.children.indexOf(child);
      if (index === -1) {
        throw new Error("The supplied DisplayObject must be a child of the caller");
      }
      return index;
    }
  }, {
    key: "setChildIndex",
    value: function setChildIndex(child, index) {
      if (index < 0 || index >= this.children.length) {
        throw new Error("The index ".concat(index, " supplied is out of bounds ").concat(this.children.length));
      }
      var currentIndex = this.getChildIndex(child);
      utils.removeItems(this.children, currentIndex, 1);
      this.children.splice(index, 0, child);
      this.onChildrenChange(index);
    }
  }, {
    key: "getChildAt",
    value: function getChildAt(index) {
      if (index < 0 || index >= this.children.length) {
        throw new Error("getChildAt: Index (".concat(index, ") does not exist."));
      }
      return this.children[index];
    }
  }, {
    key: "removeChild",
    value: function removeChild() {
      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length; i++) {
          this.removeChild(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        }
      } else {
        var child = arguments.length <= 0 ? undefined : arguments[0];
        var index = this.children.indexOf(child);
        if (index === -1) return null;
        child.parent = null;
        child.transform._parentID = -1;
        utils.removeItems(this.children, index, 1);
        this._boundsID++;
        this.onChildrenChange(index);
        child.emit("removed", this);
        this.emit("childRemoved", child, this, index);
      }
      return arguments.length <= 0 ? undefined : arguments[0];
    }
  }, {
    key: "removeChildAt",
    value: function removeChildAt(index) {
      var child = this.getChildAt(index);
      child.parent = null;
      child.transform._parentID = -1;
      utils.removeItems(this.children, index, 1);
      this._boundsID++;
      this.onChildrenChange(index);
      child.emit("removed", this);
      this.emit("childRemoved", child, this, index);
      return child;
    }
  }, {
    key: "removeChildren",
    value: function removeChildren() {
      var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var endIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.children.length;
      var begin = beginIndex;
      var end = endIndex;
      var range = end - begin;
      var removed;
      if (range > 0 && range <= end) {
        removed = this.children.splice(begin, range);
        for (var i = 0; i < removed.length; ++i) {
          removed[i].parent = null;
          if (removed[i].transform) {
            removed[i].transform._parentID = -1;
          }
        }
        this._boundsID++;
        this.onChildrenChange(beginIndex);
        for (var _i = 0; _i < removed.length; ++_i) {
          removed[_i].emit("removed", this);
          this.emit("childRemoved", removed[_i], this, _i);
        }
        return removed;
      } else if (range === 0 && this.children.length === 0) {
        return [];
      }
      throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
  }, {
    key: "sortChildren",
    value: function sortChildren() {
      var sortRequired = false;
      for (var i = 0, j = this.children.length; i < j; ++i) {
        var child = this.children[i];
        child._lastSortedIndex = i;
        if (!sortRequired && child.zIndex !== 0) {
          sortRequired = true;
        }
      }
      if (sortRequired && this.children.length > 1) {
        this.children.sort(_sortChildren);
      }
      this.sortDirty = false;
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      if (this.sortableChildren && this.sortDirty) {
        this.sortChildren();
      }
      this._boundsID++;
      this.transform.updateTransform(this.parent.transform);
      this.worldAlpha = this.alpha * this.parent.worldAlpha;
      for (var i = 0, j = this.children.length; i < j; ++i) {
        var child = this.children[i];
        if (child.visible) {
          child.updateTransform();
        }
      }
    }
  }, {
    key: "calculateBounds",
    value: function calculateBounds() {
      this._bounds.clear();
      this._calculateBounds();
      for (var i = 0; i < this.children.length; i++) {
        var child = this.children[i];
        if (!child.visible || !child.renderable) {
          continue;
        }
        child.calculateBounds();
        if (child._mask) {
          var maskObject = child._mask.isMaskData ? child._mask.maskObject : child._mask;
          if (maskObject) {
            maskObject.calculateBounds();
            this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
          } else {
            this._bounds.addBounds(child._bounds);
          }
        } else if (child.filterArea) {
          this._bounds.addBoundsArea(child._bounds, child.filterArea);
        } else {
          this._bounds.addBounds(child._bounds);
        }
      }
      this._bounds.updateID = this._boundsID;
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds(rect) {
      var skipChildrenUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = _get(_getPrototypeOf(Container.prototype), "getLocalBounds", this).call(this, rect);
      if (!skipChildrenUpdate) {
        for (var i = 0, j = this.children.length; i < j; ++i) {
          var child = this.children[i];
          if (child.visible) {
            child.updateTransform();
          }
        }
      }
      return result;
    }
  }, {
    key: "_calculateBounds",
    value: function _calculateBounds() {}
  }, {
    key: "_renderWithCulling",
    value: function _renderWithCulling(renderer) {
      var sourceFrame = renderer.renderTexture.sourceFrame;
      if (!(sourceFrame.width > 0 && sourceFrame.height > 0)) {
        return;
      }
      var bounds;
      var transform;
      if (this.cullArea) {
        bounds = this.cullArea;
        transform = this.worldTransform;
      } else if (this._render !== Container.prototype._render) {
        bounds = this.getBounds(true);
      }
      var projectionTransform = renderer.projection.transform;
      if (projectionTransform) {
        if (transform) {
          transform = tempMatrix.copyFrom(transform);
          transform.prepend(projectionTransform);
        } else {
          transform = projectionTransform;
        }
      }
      if (bounds && sourceFrame.intersects(bounds, transform)) {
        this._render(renderer);
      } else if (this.cullArea) {
        return;
      }
      for (var i = 0, j = this.children.length; i < j; ++i) {
        var child = this.children[i];
        var childCullable = child.cullable;
        child.cullable = childCullable || !this.cullArea;
        child.render(renderer);
        child.cullable = childCullable;
      }
    }
  }, {
    key: "render",
    value: function render(renderer) {
      var _this$filters;
      if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
        return;
      }
      if (this._mask || (_this$filters = this.filters) !== null && _this$filters !== void 0 && _this$filters.length) {
        this.renderAdvanced(renderer);
      } else if (this.cullable) {
        this._renderWithCulling(renderer);
      } else {
        this._render(renderer);
        for (var i = 0, j = this.children.length; i < j; ++i) {
          this.children[i].render(renderer);
        }
      }
    }
  }, {
    key: "renderAdvanced",
    value: function renderAdvanced(renderer) {
      var _this$_enabledFilters, _this$_enabledFilters2, _this$_enabledFilters3;
      var filters = this.filters;
      var mask = this._mask;
      if (filters) {
        if (!this._enabledFilters) {
          this._enabledFilters = [];
        }
        this._enabledFilters.length = 0;
        for (var i = 0; i < filters.length; i++) {
          if (filters[i].enabled) {
            this._enabledFilters.push(filters[i]);
          }
        }
      }
      var flush = filters && ((_this$_enabledFilters = this._enabledFilters) === null || _this$_enabledFilters === void 0 ? void 0 : _this$_enabledFilters.length) || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== MASK_TYPES.NONE));
      if (flush) {
        renderer.batch.flush();
      }
      if (filters && (_this$_enabledFilters2 = this._enabledFilters) !== null && _this$_enabledFilters2 !== void 0 && _this$_enabledFilters2.length) {
        renderer.filter.push(this, this._enabledFilters);
      }
      if (mask) {
        renderer.mask.push(this, this._mask);
      }
      if (this.cullable) {
        this._renderWithCulling(renderer);
      } else {
        this._render(renderer);
        for (var _i2 = 0, j = this.children.length; _i2 < j; ++_i2) {
          this.children[_i2].render(renderer);
        }
      }
      if (flush) {
        renderer.batch.flush();
      }
      if (mask) {
        renderer.mask.pop(this);
      }
      if (filters && (_this$_enabledFilters3 = this._enabledFilters) !== null && _this$_enabledFilters3 !== void 0 && _this$_enabledFilters3.length) {
        renderer.filter.pop();
      }
    }
  }, {
    key: "_render",
    value: function _render(_renderer) {}
  }, {
    key: "destroy",
    value: function destroy(options) {
      _get(_getPrototypeOf(Container.prototype), "destroy", this).call(this);
      this.sortDirty = false;
      var destroyChildren = typeof options === "boolean" ? options : options === null || options === void 0 ? void 0 : options.children;
      var oldChildren = this.removeChildren(0, this.children.length);
      if (destroyChildren) {
        for (var i = 0; i < oldChildren.length; ++i) {
          oldChildren[i].destroy(options);
        }
      }
    }
  }, {
    key: "width",
    get: function get() {
      return this.scale.x * this.getLocalBounds().width;
    },
    set: function set(value) {
      var width = this.getLocalBounds().width;
      if (width !== 0) {
        this.scale.x = value / width;
      } else {
        this.scale.x = 1;
      }
      this._width = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this.scale.y * this.getLocalBounds().height;
    },
    set: function set(value) {
      var height = this.getLocalBounds().height;
      if (height !== 0) {
        this.scale.y = value / height;
      } else {
        this.scale.y = 1;
      }
      this._height = value;
    }
  }]);
  return Container;
}(DisplayObject);
Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
export { Container };